module.exports = __webpack_public_path__ + "media/common/icon_privacy-78a4a519.png";